/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsObjectsIntegrationState } from './WebApiIntegrationsObjectsIntegrationState';
import {
    WebApiIntegrationsObjectsIntegrationStateFromJSON,
    WebApiIntegrationsObjectsIntegrationStateFromJSONTyped,
    WebApiIntegrationsObjectsIntegrationStateToJSON,
} from './WebApiIntegrationsObjectsIntegrationState';
import type { WebApiIntegrationsObjectsIntegrationType } from './WebApiIntegrationsObjectsIntegrationType';
import {
    WebApiIntegrationsObjectsIntegrationTypeFromJSON,
    WebApiIntegrationsObjectsIntegrationTypeFromJSONTyped,
    WebApiIntegrationsObjectsIntegrationTypeToJSON,
} from './WebApiIntegrationsObjectsIntegrationType';

/**
 * Integration health status for a company
 * @export
 * @interface WebApiAdminDtoIntegrationStatusDto
 */
export interface WebApiAdminDtoIntegrationStatusDto {
    /**
     * Integration ID
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    integrationId?: number;
    /**
     * Company name
     * @type {string}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    companyName?: string | null;
    /**
     * Company ID
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    companyId?: number;
    /**
     * 
     * @type {WebApiIntegrationsObjectsIntegrationType}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    type?: WebApiIntegrationsObjectsIntegrationType;
    /**
     * 
     * @type {WebApiIntegrationsObjectsIntegrationState}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    state?: WebApiIntegrationsObjectsIntegrationState;
    /**
     * Last time the integration was run
     * @type {Date}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    lastRun?: Date | null;
    /**
     * Response from the last run
     * @type {string}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    lastRunResponse?: string | null;
    /**
     * Whether the integration is healthy
     * @type {boolean}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    isHealthy?: boolean;
    /**
     * Health message or error description
     * @type {string}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    healthMessage?: string | null;
    /**
     * When the access token expires
     * @type {Date}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    accessTokenExpires?: Date | null;
    /**
     * Whether the token is expiring within 7 days
     * @type {boolean}
     * @memberof WebApiAdminDtoIntegrationStatusDto
     */
    isTokenExpiringSoon?: boolean;
}

/**
 * Check if a given object implements the WebApiAdminDtoIntegrationStatusDto interface.
 */
export function instanceOfWebApiAdminDtoIntegrationStatusDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoIntegrationStatusDtoFromJSON(json: any): WebApiAdminDtoIntegrationStatusDto {
    return WebApiAdminDtoIntegrationStatusDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoIntegrationStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoIntegrationStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'integrationId': !exists(json, 'integrationId') ? undefined : json['integrationId'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'type': !exists(json, 'type') ? undefined : WebApiIntegrationsObjectsIntegrationTypeFromJSON(json['type']),
        'state': !exists(json, 'state') ? undefined : WebApiIntegrationsObjectsIntegrationStateFromJSON(json['state']),
        'lastRun': !exists(json, 'lastRun') ? undefined : (json['lastRun'] === null ? null : new Date(json['lastRun'])),
        'lastRunResponse': !exists(json, 'lastRunResponse') ? undefined : json['lastRunResponse'],
        'isHealthy': !exists(json, 'isHealthy') ? undefined : json['isHealthy'],
        'healthMessage': !exists(json, 'healthMessage') ? undefined : json['healthMessage'],
        'accessTokenExpires': !exists(json, 'accessTokenExpires') ? undefined : (json['accessTokenExpires'] === null ? null : new Date(json['accessTokenExpires'])),
        'isTokenExpiringSoon': !exists(json, 'isTokenExpiringSoon') ? undefined : json['isTokenExpiringSoon'],
    };
}

export function WebApiAdminDtoIntegrationStatusDtoToJSON(value?: WebApiAdminDtoIntegrationStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'integrationId': value.integrationId,
        'companyName': value.companyName,
        'companyId': value.companyId,
        'type': WebApiIntegrationsObjectsIntegrationTypeToJSON(value.type),
        'state': WebApiIntegrationsObjectsIntegrationStateToJSON(value.state),
        'lastRun': value.lastRun === undefined ? undefined : (value.lastRun === null ? null : value.lastRun.toISOString()),
        'lastRunResponse': value.lastRunResponse,
        'isHealthy': value.isHealthy,
        'healthMessage': value.healthMessage,
        'accessTokenExpires': value.accessTokenExpires === undefined ? undefined : (value.accessTokenExpires === null ? null : value.accessTokenExpires.toISOString()),
        'isTokenExpiringSoon': value.isTokenExpiringSoon,
    };
}

